/**
 =========================================================
 * Material Dashboard 2 PRO React - v2.1.0
 =========================================================
 
 * Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
 * Copyright 2022 Creative Tim (https://www.creative-tim.com)
 
 * Coded by www.creative-tim.com
 
 =========================================================
 
 * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
 */

// @mui material components
import Card from "@mui/material/Card";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";

// Material Dashboard 2 PRO React examples
import DataTable from "examples/Tables/DataTable";

//React Hooks and Others
import { Link, useNavigate } from "react-router-dom";
import React, { useState } from "react";
import { CircularProgress, Icon, Tooltip } from "@mui/material";
import PropTypes from "prop-types";

import ComponentsPrivatization from "config/component_privatization";
import { style_icon } from "helpers/global_vars";
import { AUXILIAR_DOCENTE, COORDINADOR_DOCENTE } from "roles";
import { useGetTemplatesQuery } from "services/escuela/modelos_pdf/usecases/getTemplates";
import usePagination from "hooks/usePagination";

function DataTableModelosPdf({ tableHeader }) {
  const navigate = useNavigate();

  const { offset, setOffset, limit, handleNext, handlePrevious, busqueda, setBusqueda } =
    usePagination();

  const {
    data: plantilla,
    isError: isErrorG,
    isLoading: isLoadingG,
    error: errorG,
    isFetching,
  } = useGetTemplatesQuery({
    filterParams: {
      limit: limit,
      offset: offset,
      buscar: busqueda,
    },
  });

  //Constantes para manejar la paginacion
  const dataPlantilla = plantilla?.results ? plantilla.results : plantilla;
  const countTotal = plantilla?.count;
  const previous = plantilla?.previous;
  const next = plantilla?.next;

  const dataTable = {
    columns: [
      {
        Header: "Nombre de Plantilla",
        accessor: "nombre",
        Cell: ({ value }) => {
          return value ? value : "-------------";
        },
      },
      {
        Header: "Activa",
        accessor: "imagenes",
        Cell: ({ value }) => {
          return (
            <MDBox display="flex">
              <MDBox px={0.2}>
                <Icon
                  fontSize="small"
                  color={
                    value.find((e) => e.espacio === "header").imagen
                      ? "success"
                      : "error"
                  }
                >
                  lightbulb
                </Icon>
              </MDBox>
            </MDBox>
          );
        },
      },
      {
        Header: "Acciones",
        accessor: "actions",
        width: "1%",
        Cell: ({ row }) => {
          const { original } = row;

          return (
            <MDBox display="flex">
              <ComponentsPrivatization
                permitted={[AUXILIAR_DOCENTE, COORDINADOR_DOCENTE]}
              >
                <MDBox px={0.2}>
                  <Tooltip
                    placement="top"
                    title="Editar la información del estudiante"
                  >
                    <Icon
                      style={style_icon}
                      onClick={() => handleClickEdit(original)}
                      fontSize="small"
                    >
                      edit
                    </Icon>
                  </Tooltip>
                </MDBox>
              </ComponentsPrivatization>
            </MDBox>
          );
        },
      },
    ],

    rows: dataPlantilla ?? [],
  };

  const handleClickEdit = ({ id, tipo }) => {
    navigate(`/configuración/modelos/editar/${id}/tipo/${tipo}`);
  };

  return (
    <MDBox pt={0} pb={3}>
      <MDBox display="flex" justifyContent={"center"} alignItems={"center"}>
        {isLoadingG || isFetching ? (
          <CircularProgress sx={{ marginBottom: "3rem" }} color="inherit" />
        ) : (
          <DataTable
            tableHeader={tableHeader}
            table={dataTable}
            canSearch
            paginationApi
            countTotal={countTotal}
            next={next}
            previous={previous}
            handleNext={handleNext}
            handlePrevious={handlePrevious}
            setBusqueda={setBusqueda}
            offset={offset}
            setOffset={setOffset}
          />
        )}
      </MDBox>
    </MDBox>
  );
}

DataTableModelosPdf.propTypes = {
  tableHeader: PropTypes.string.isRequired,
};

export default DataTableModelosPdf;
